// Modal.js

import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import styles from "./Modal.module.scss";
import { sendMessage } from "../../lib/postMessage";
import {
  ADD_FAVOURITES_VIEW,
  CHANGE_NAME_VIEW,
  EDIT_FAVOURITES_VIEW,
  MY_FAVOURITES_VIEW,
  UPDATE_FAVOURITES_VIEW,
  WARNING_VIEW,
} from "../../constants";
import { useSelector } from "react-redux";

const element = document.createElement("div");
const filterElement = document.createElement("div");

function Modal({ children, loading = false, variant = "default" }) {
  const { activeFilterView, activeView } = useSelector((state) => state.view);
  const modalRef = React.useRef(null);
  const heightRef = React.useRef(null);
  const modalView = variant === "filter" ? "filter" : "portal";
  useEffect(() => {
    if (children) {
      document.querySelector("#root").style.display = "none";
    }
    if (modalView === "portal" && activeFilterView !== "") {
      document.querySelector("#portal").style.display = "none";
      document.querySelector("#filter").style.display = "inherit";
    }

    if (modalView === "portal" && activeFilterView === "") {
      document.querySelector("#portal").style.display = "inherit";
      document.querySelector("#filter").style.display = "none";
    }
    if (
      activeView === UPDATE_FAVOURITES_VIEW ||
      activeView === CHANGE_NAME_VIEW ||
      activeView === ADD_FAVOURITES_VIEW ||
      activeView === MY_FAVOURITES_VIEW ||
      activeView === EDIT_FAVOURITES_VIEW ||
      activeView === WARNING_VIEW
    ) {
      document.querySelector("#portal").style.display = "inherit";
      document.querySelector("#filter").style.display = "none";
    }
    if (modalView === "filter") {
      document.querySelector("#portal").style.display = "none";
      document.querySelector("#filter").style.display = "inherit";
    }

    return () => {
      document.querySelector("#root").style.display = "inherit";
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [children, activeView, activeFilterView]);

  useEffect(() => {
    const modalRoot = document.getElementById(modalView);
    if (modalView === "filter") {
      modalRoot.appendChild(filterElement);
    } else {
      modalRoot.appendChild(element);
    }

    if (typeof window !== "undefined") {
      window.scroll({ top: 0 });
    }

    return () => {
      if (modalView === "filter") {
        modalRoot.removeChild(filterElement);
      } else {
        modalRoot.removeChild(element);
      }
    };
  }, [modalView]);

  useEffect(() => {
    // create an observer instance to watch for the modalRef
    // being updated with new child elements
    const observer = new ResizeObserver((entries) => {
      const { height } = entries[0].contentRect;
      // added check for loading due to the BetShuffle component being re-rendered
      // this is down to us having a loading and selections state in the BetShuffle component
      // we don't want to send the message to the parent when the component is loading
      // as this will likely be the height of the skeleton
      if (height === 0 || loading || height < heightRef.current) return;
      // on some occasions the initial height is before the animation has finished
      // so it will be slightly off, we add a small shift to the height to account for this
      // and we reduce the amount of messages being sent to the parent
      const animationShiftHeight = 26;
      heightRef.current = height + animationShiftHeight;
      // send message to the parent with the updated height
      sendMessage({
        type: "HeightChanged",
        payload: {
          height: height + animationShiftHeight,
        },
      });
    });
    // start observing of the modalRef element
    observer.observe(modalRef.current);
    // when the component unmounts, stop observing
    return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalRef.current, loading]);

  return createPortal(
    <div className={styles.modal} ref={modalRef}>
      {children}
    </div>,
    modalView === "filter" ? filterElement : element
  );
}

export default Modal;
